import { Routes } from '@angular/router';
import { LoginGuard } from './auth/guards/login.guard';
import { HomePageComponent } from './home/page/home-page.component';
import { AuthGuard } from './auth/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/login.routes'),
    canMatch: [LoginGuard],
  },
  {
    path: '',
    component: HomePageComponent,
    canMatch: [AuthGuard],
  },
  {
    path: 'Notificaciones',
    loadChildren: () => import('./notifications/notifications.routes'),
    canMatch: [AuthGuard],
  },
  {
    path: 'Contenidos',
    canMatch: [AuthGuard],
    children: [
      {
        path: 'Amenidades',
        loadChildren: () => import('./pages/contents/amenities/amenities.routing'),
        canMatch: [AuthGuard],
      }
    ]
  },
  {
    path: 'Reportes',
    loadChildren: () => import('./pages/reports/support/support.routing'),
    canMatch: [AuthGuard],
    
  },
  {
    path: '**',
    redirectTo: 'auth',
    canMatch: [LoginGuard],
  }
];
